<template>
  <div v-if="!loading" class="page">
    <page-header></page-header>
    <progress-bar :percentage="50"></progress-bar>

    <div class="container _margin-bottom-30">
      <div class="row">
        <div class="col-md-12">
          <h5 class="_margin-top-20">Choose a Tariff</h5>
          <div class="alert alert-info _margin-top-20" v-if="!loading && results.length == 0">
            No results found {{ unfilteredResults.length == 0 ? '' : 'for you chosen filters' }}
          </div>

          <result-item v-for="result in results" :data="result" :key="`${result.tariffId}${result.payMethod}`"
            @onMore="onMore(result)" @onChoose="onProceed(result)"></result-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResultItem from '@/components/quote-results/ResultItem';
import CollaspableSidebar from '@/components/quote-results/CollaspableSidebar';
import ProgressBar from '@/components/progress/ProgressBar';
import PageHeader from '@/components/page-header/PageHeader';

import { mapGetters, mapState } from 'vuex';

export default {
  name: 'QuoteResults',
  async mounted() {
    await this.$store.dispatch('token/getToken');
    const preventRefresh = ['tariffDetails', 'personalDetails'];

    if (preventRefresh.indexOf(this.prevRoute.name) < 0 || this.results.length == 0) {
      await this.$store.dispatch('quote_results/getQuoteResults');

      if (this.unfilteredResults.length > 0) {
        await this.$store.dispatch('quote_results/getCurrentTariff', this.unfilteredResults[0].tariffId);
      }
    }

    this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Quotes Results' });
    this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Viewed' });
    this.$store.dispatch('tracing/saveActions');
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapGetters({
      results: 'quote_results/results'
    }),
    ...mapState({
      carbonOffsetEquivalent: ({ carbon_offset }) => carbon_offset.equivalent,
      loading: ({ page_loader }) => page_loader.show,
      unfilteredResults: ({ quote_results }) => quote_results.results,
      currentTariff: ({ quote_results }) => quote_results.currentTariff
    })
  },
  methods: {
    async onMore({ tariffId, tariffName, supplierName, payMethod, switchOption }) {
      await this.$store.dispatch('storage/save', {
        prop: 'quote',
        value: { proposedPayMethod: payMethod, switchOption }
      });

      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Quote Results' });
      this.$store.dispatch('tracing/addAction', { name: 'Tariff Id', value: tariffId });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Tariff Details' });
      await this.$store.dispatch('tracing/saveActions');

      this.$router.push({
        name: 'tariffDetails',
        params: { tariffId }
      });
    },
    async onProceed({ tariffId, payMethod }) {
      await this.$store.dispatch('storage/save', {
        prop: 'quote',
        value: { proposedPayMethod: payMethod }
      });
      await this.$store.dispatch('quote_results/switchNow', { tariffId });
      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Quote Results' });
      this.$store.dispatch('tracing/addAction', { name: 'Tariff Id', value: tariffId });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Switch Now' });
      await this.$store.dispatch('tracing/saveActions');
    },
    onToggleFilter() {
      this.$refs.sidebar.toggleOpen();
    }
  },
  components: {
    ResultItem,
    CollaspableSidebar,
    PageHeader,
    ProgressBar
  }
};
</script>

<style lang="scss" scoped>
.page {
  .progressbar {
    position: fixed;
    border-radius: 0;
    top: 0;
    left: 0;
    z-index: 1000;
    max-width: 992px;
  }
}
</style>
